import Card from 'react-bootstrap/Card'

const TeamSpiritLoadError = ({ message, cardStyle }) => {
  if (!message) return null

  return (
    <Card
      className="mt-3 mb-4"
      style={{
        ...cardStyle,
        borderColor: '#dc3545',
        backgroundColor: '#fff5f5',
      }}
    >
      <Card.Body>
        <h5 style={{ color: '#dc3545' }}>Virhe:</h5>
        <p style={{ color: '#666' }}>{message}</p>
      </Card.Body>
    </Card>
  )
}

export default TeamSpiritLoadError
